import React, { useEffect, useState ,useRef} from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
 import VersionUpdateAbstract from './VersionUpdateAbstract ';
 import VersionNotUpdateList from './VersionNotUpdateAbstract '

const Version_abstract_data = async () => {
    const response = await fetch(`${process.env.REACT_APP_URL_MIS}/api/VersionAbstract`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    return response.json();
  };
const Version_abstract = () => {
    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading, setTabHeading] = useState(null);
    const fpstab = useRef(null); // Use ref to scroll to this div
    const [renderContenttttt, setRenderContenttttt] = useState(null);
    const details3 = useRef(null); // Use ref to scroll to this div

    const [version, setVersion] = useState(null);

    const handleFPSClick = (type,dist_code) => {
      setRenderContenttttt(null);

      setTimeout(() => {

        setRenderContenttttt(() => {
             
if(type==='U'){
return(<VersionUpdateAbstract  
  dist_code={dist_code} />
);
}else if (type==='N')
{
  return(
    <VersionNotUpdateList  
  dist_code={dist_code} />
  );
}
});
      }, 10);
  };


    useEffect(() => {
      const getData = async () => {
        try {
          const response_data = await Version_abstract_data();
          setTabHeading(response_data.heading);
  
          if (response_data.versionAbstractList && response_data.versionAbstractList.length > 0) {
            setReportData(response_data.versionAbstractList);
            setVersion(response_data.headerversionNo)
          } else {
            setReportData([]);
          }
        } catch (errorr) {
            return <div className="mainhead" align="center">Internal error</div>;
        } finally {
          setLoading(false);
        }
      };
  
      getData();
    }, []);
  
    useEffect(() => {
      if (!loading && !error && reportData.length > 0 && details3.current) {
        details3.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, [loading, error, reportData]);
  
    if (loading) {
      return <div style={{display:'flex', justifyContent:'center',alignItems:'center'}}><Box sx={{ display: 'flex'}}>
          <CircularProgress />
      </Box></div>
  }
  if (error) {
      return <div class="mainhead" align="center">
      Internal Error
      </div>
    }
    if (reportData.length === 0) {
        return <div class="mainhead" align="center">
		No data found 
 	</div>
      }
    // Calculate totals for each column
    const totals = reportData.reduce(
      (acc, item) => {
        acc.total_shops += parseInt(item.total_shops) || 0;
        acc.new_version += item.downloaded || 0;
        acc.old_version += item.not_loged || 0;
        
        return acc;
      },
      {
        total_shops: 0,
        new_version: 0,
        old_version: 0
         
      }
    );
        
    
    return (
      <><br/><br/>
        <table ref={fpstab} align="center" width="70%" border={1}>
          <thead>
            <tr className="tableheader">
              <th colSpan={17}> {'New Version' } {version} { 'update report'}</th>
            </tr>
            <tr className="tableheader">
              <th rowSpan={3}>Sl.No</th>
              <th rowSpan={3}>District</th>
              <th rowSpan={3}>Total<br/>Shops</th>
              <th rowSpan={3}>New Version<br/>Shops</th>
              <th rowSpan={3}>Old Version<br/>Shops</th>
              <th colSpan={6}>Updated<br/>%</th>
             </tr>
           
          </thead>
          <tbody>
            {reportData.map((item, index) => (
              <tr key={item.dist_code}>
                <td  style={{ textAlign: 'center' }}>{index + 1}</td>
                <td style={{ textAlign: 'left' }}>{item.dist_name_en}</td>
                <td style={{ textAlign: 'right' }}>{item.total_shops}</td>

                <td style={{ textAlign: 'right' }}>
                {item.downloaded === 0 ? (
    item.downloaded
  ) : (
    <a
      style={{ cursor: 'pointer', color: 'blue' }}
      onClick={() => handleFPSClick('U',item.dist_code)}
    >
      {item.downloaded}
    </a>
  )}
                 </td>
 
 
                 <td style={{ textAlign: 'right' }}>
                 {item.not_download_shop === 0 ? (
    item.not_loged
  ) : (
    <a
      style={{ cursor: 'pointer', color: 'blue' }}
      onClick={() => handleFPSClick('N',item.dist_code)}
    >
      {item.not_loged}
    </a>
  )}
               
                 </td>
 
 
                 <td style={{ textAlign: 'right' }}>
               
                    {item.download_per}
                  </td>
 

              </tr>
            ))}
            <tr className="tableheader">
              <td colSpan={2} style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.total_shops}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.new_version}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{totals.old_version}</td>
              <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{}</td>

            </tr>
          </tbody>
        </table>
        <br /><br />
        <div id='detailsRR' ref={details3}>{renderContenttttt}</div>
        <br /><br />

      </>
    );
  };
  
  export default Version_abstract;
  